    (async function () {
      const { S, esc, qs, img, shopUrl, getProducts, editorialImages, productCard, skeletons } = window.Store;
      const type = qs("type");
      const sort = qs("sort") || "new";
      const cat = S.categories.find((c) => c.type === type);
      const title = cat ? cat.label : "All jewelry";
      document.title = `${title} — manej`;
      document.querySelector("[data-heading]").textContent = title;

      const desc = document.querySelector("[data-desc]");
      desc.querySelector("p").textContent = cat ? cat.text : S.shopAllText;
      const more = desc.querySelector("[data-more]");
      more.onclick = () => { desc.classList.toggle("clamped"); more.textContent = desc.classList.contains("clamped") ? "Read more" : "Read less"; };
      requestAnimationFrame(() => { const p = desc.querySelector("p"); if (p.scrollHeight <= p.clientHeight + 2) more.hidden = true; });

      const withSort = (t) => { const u = new URL(shopUrl(t), location.href); if (sort !== "new") u.searchParams.set("sort", sort); return u.pathname + u.search; };
      document.querySelector("[data-subnav]").innerHTML =
        `<a href="${withSort()}" class="${type ? "" : "active"}">All jewelry</a>` +
        S.categories.map((c) => `<a href="${withSort(c.type)}" class="${c.type === type ? "active" : ""}">${esc(c.label)}</a>`).join("") +
        `<label class="sort">Sort
          <select data-sort>
            <option value="new">Newest</option>
            <option value="price-asc">Price: low to high</option>
            <option value="price-desc">Price: high to low</option>
          </select></label>`;
      const select = document.querySelector("[data-sort]");
      select.value = sort;
      select.onchange = () => { const u = new URL(location.href); u.searchParams.set("sort", select.value); location.href = u; };

      const sortArgs = { new: { sortKey: "CREATED_AT", reverse: true }, "price-asc": { sortKey: "PRICE", reverse: false }, "price-desc": { sortKey: "PRICE", reverse: true } }[sort] || {};
      const grid = document.querySelector("[data-grid]");
      grid.innerHTML = skeletons(8);
      try {
        const products = await getProducts({ type, ...sortArgs });
        if (!products.length) { grid.innerHTML = `<p class="notice">Nothing here yet — <a class="link" href="/collections/all">see all jewelry</a></p>`; return; }
        const cards = products.map((p) => productCard(p));
        const looks = editorialImages(products);
        if (looks.length && cards.length > 4) {
          const look = looks[looks.length - 1];
          cards.splice(2, 0, `<a class="look" href="${esc("/products/" + look.product.handle)}"><img src="${img(look.url, 1400)}" alt="" loading="lazy"><span>Total look</span></a>`);
        }
        grid.innerHTML = cards.join("");
      } catch (e) {
        console.error(e);
        grid.innerHTML = `<p class="notice">We couldn't load the collection. Please refresh the page.</p>`;
      }
    })();
  